/**
 * Authentication hooks
 * This is the ONLY way components should access auth state
 */
import { useContext } from 'react';
import { AuthContext } from '../context';
import { AuthContextState } from '../types';

/**
 * Hook to access authentication context
 * @throws Error if used outside of an AuthProvider
 */
export const useAuth = (): AuthContextState => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
